module.exports = __webpack_public_path__ + "static/media/icon-kallah.f1bdc275.svg";